import isElectron from 'is-electron';
import styled from 'styled-components';
import { palette } from '../../theme/colors';

export const LayoutContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  height: 100vh;
  min-height: 100vh;

  background-color: ${props =>
    isElectron() ? props.theme.palette.background.primary : palette.darkblack};
`;

export const MainWrapper = styled.div`
  flex-grow: 1;
  display: flex;
  align-items: stretch;
  overflow-y: auto;
  &::-webkit-scrollbar {
    display: none;
  }
  -ms-overflow-style: none;
  scrollbar-width: none;
`;

export const SMain = styled.main<{ backgroundColor?: string; extraFooterPadding: boolean }>`
  display: flex;
  flex-direction: column;
  background-color: ${props => props.backgroundColor ?? props.theme.palette.background.primary};
  /* footer height  */
  padding-bottom: ${props => (props.extraFooterPadding ? '4.81rem' : 0)};
  width: 100%;
  max-width: 26rem;
  margin-inline: auto;
`;
